import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useFormik } from 'formik'
import * as yup from 'yup'

import Row from 'components/Row'
import Spacer from 'components/Spacer'
import Button from 'components/Button'
import TextField from 'components/TextField'
import TextArea from 'components/TextArea'
import { post } from 'service/api'

const initialValues = {
  name: '',
  email: '',
  phone: '',
  message: '',
}

export default function ModalDatabases({ onClose }) {
  const { t } = useTranslation()
  const [messageSuccess, setMessageSuccess] = useState(false)
  const [messageError, setMessageError] = useState(false)

  const validationSchema = yup.object({
    name: yup.string().required(t('summary.form.validation.required')),
    email: yup
      .string()
      .email(t('summary.form.validation.invalid_email'))
      .required(t('summary.form.validation.required')),
    phone: yup
      .string()
      .length(14, t('summary.form.validation.invalid_phone'))
      .required(t('summary.form.validation.required')),
    message: yup.string().required(t('summary.form.validation.required')),
  })

  const formik = useFormik({
    initialValues,
    onSubmit: (values) => {
      handleSubmit(values)
    },
    validationSchema,
  })

  const handleSubmit = async (values) => {
    setMessageSuccess(false)
    setMessageError(false)
    const res = await post({ url: '/message', data: values })
    if (res) {
      formik.handleReset()
      setMessageSuccess(true)
    } else {
      setMessageError(true)
    }
  }

  return (
    <form onSubmit={formik.handleSubmit} className="form">
      <Spacer height={20} />
      <TextField
        config={{
          name: 'name',
          placeholder: t('home.form.name'),
          inputwidth: '100%',
          labelwidth: '0',
        }}
        formik={formik}
      />
      <Row align="center">
        <TextField
          config={{
            name: 'email',
            placeholder: t('home.form.email'),
            inputwidth: 240,
            labelwidth: '0',
          }}
          formik={formik}
        />
        <Spacer width={10} />
        <TextField
          config={{
            name: 'phone',
            placeholder: t('home.form.phone_number'),
            mask: 'phoneUS',
            labelwidth: '0',
          }}
          formik={formik}
        />
      </Row>
      <TextArea
        config={{
          name: 'message',
          placeholder: t('home.form.message'),
          labelwidth: '0',
        }}
        formik={formik}
      />

      {messageSuccess && (
        <p className="message_text success">{t('message.success')}</p>
      )}
      {messageError && (
        <p className="message_text error">{t('message.error')}</p>
      )}

      <Row>
        <Button type="button" onClick={onClose} label={t('button.close')} />
        <Spacer width={30} />
        <Button type="submit" className="primary" label={t('button.submit')} />
      </Row>
    </form>
  )
}
